import { render } from "./CompetentionLogoPlus.vue?vue&type=template&id=47444472"
import script from "./CompetentionLogoPlus.vue?vue&type=script&lang=js"
export * from "./CompetentionLogoPlus.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__